import "./index.scss";
import HomeMap from "../../assets/img/Homescreen-full-map.png";
import VerticalLine from "../../components/icons/VerticalLine";
import Logo from "../../components/icons/Logo";
import Touch from "../../assets/img/Blue-Touch-Icon.gif";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import ConferenceCenterAndBallroom from "../../components/icons/NavIcons/ConferenceCenterAndBallroom";
import DormRooms from "../../components/icons/NavIcons/DormRooms";
import CampusDining from "../../components/icons/NavIcons/CampusDining";
import MainCampus from "../../components/icons/NavIcons/MainCampus";
import Athletics from "../../components/icons/NavIcons/Athletics";
const LandingPage = () => { 
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash landingPage">
            <div className="home-map">
                <div className="dorm-rooms">
                    <DormRooms onClick={()=>{
                        _logEvent('click', "Main Map", "Dorm Rooms");
                        addFlow("Dorm Rooms");
                        navigate("/dorm-rooms");
                    }} />
                </div>
                <div className="campus-dining">
                    <CampusDining onClick={()=>{
                        _logEvent('click', "Main Map", "Campus Dining");
                        addFlow("Campus Dining");
                        navigate("/campus-dining");
                    }} />
                </div>
                <div className="main-campus">
                    <MainCampus onClick={()=>{
                        _logEvent('click', "Main Map", "Main Campus");
                        addFlow("Main Campus");
                        navigate("/main-campus");
                    }} />
                </div>
                <div className="athletics">
                    <Athletics onClick={()=>{
                        _logEvent('click', "Main Map", "Athletics");
                        addFlow("Athletics");
                        navigate("/athletics");
                    }} />
                </div>
                <div className="conference-ballroom">
                    <ConferenceCenterAndBallroom onClick={()=>{
                        _logEvent('click', "Main Map", "Conference Center And Ballroom");
                        addFlow("Conference Center And Ballroom");
                        navigate("/conference-and-ballroom");
                    }} />
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Main Map", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus");
            }}><Logo /></div>
            <div className="top-left">
                <div className="topic-header">
                    Maximize Return on Experience{'\n'}
                    <span className="sub-topic-header">
                        For <strong>Higher Education</strong>
                    </span>
                </div>
                <div className="column">
                    <div className="row"><span>Delight</span> students and faculty</div>
                    <div className="row"><span>Retain</span> staff</div>
                    <div className="row"><span>Grow</span> margins</div>
                    <div className="line"><VerticalLine /></div>
                </div>
            </div>
            
            <div className="bottom-left">
                <img className="touch-prompt" src={Touch} alt=""/>
                <div className="block">
                    Explore our interactive{'\n'}
                    Higher Education map to discover where{'\n'}
                    <span>personal</span> meets <span>profitable</span>{'\n'}
                    <strong>Touch an area to begin!</strong>
                </div>
                
            </div>
    
        </div>
    )
}
export default LandingPage;